import { Pipe, PipeTransform } from "@angular/core";
import { NsEmpWebExpData } from "../models/emp-web-exp.model";

@Pipe({
  name: "userRequestDTOS"
})
export class UserRequestDTOSPipe implements PipeTransform {
  transform(booking: NsEmpWebExpData.IBookingDetailDTOS): boolean {
    const cabToShow = booking?.userRequestDTOS?.find(item => item.status !== "SCHEDULE_CANCELLED");
    if (cabToShow) return true;
    return false;
  }
}
